module.exports = __webpack_public_path__ + "assets/img/xah.073a0959.png";